import React from 'react'
import styles from './styles.module.css'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from './../images/circle-info-regular-full.svg'

export default function State ({ localState, setLocalState }) {
  const handleStateChange = event => {
    setLocalState(event.target.value)
  }

  return (
    <div className={styles.locationInputWrapper}>
      <div className={styles.inlineLabel}>
        <label className={styles.locationLabel} htmlFor='state'>
          State
        </label>
        <Tooltip
          title='The state of the business.'
          arrow
          placement='top'
          slotProps={{
            popper: {
              sx: {
                '& .MuiTooltip-tooltip': {
                  maxWidth: 500,
                  fontSize: '13px',
                  padding: '8px'
                }
              }
            }
          }}
        >
          <img
            src={infoIcon}
            alt='State help'
            width={14}
            height={14}
            className={styles.infoIcon}
            tabIndex={0}
          />
        </Tooltip>
      </div>
      <input
        className={styles.locationInput}
        type='text'
        id='prevent_autofill_state'
        autoComplete='off'
        placeholder='Text'
        value={localState}
        onChange={handleStateChange}
      />
    </div>
  )
}
